import React, { useState } from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
  Legend,
} from 'recharts';
import { XMarkIcon } from '@heroicons/react/24/outline';

const BillingTypeRevenueChart = () => {
  const [focusMode, setFocusMode] = useState(false);

  const data = [
    { billingType: 'Fee-for-Service', forecastRevenue: 100000, actualRevenue: 92000 },
  ];

  const renderChart = (height = 350) => (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart
        data={data}
        margin={{ top: 10, right: 30, left: 0, bottom: 30 }}
        barGap={8}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="billingType"
          tick={{ fontSize: 11 }}
          angle={-20}
          textAnchor="end"
        />
        <YAxis
          tick={{ fontSize: 12 }}
          tickFormatter={(value) => `$${(value / 1000).toFixed(0)}k`}
        />
        <Tooltip
          cursor={{ fill: 'transparent' }}
          formatter={(value) => [`$${value.toLocaleString()}`, 'Revenue']}
        />
        <Legend />
        <Bar
          dataKey="forecastRevenue"
          name="Forecast Revenue"
          fill="#1A2B5C"
          radius={[6, 6, 0, 0]}
          isAnimationActive={false}
        />
        <Bar
          dataKey="actualRevenue"
          name="Actual Revenue"
          fill="#EE1D23"
          radius={[6, 6, 0, 0]}
          isAnimationActive={false}
        />
      </BarChart>
    </ResponsiveContainer>
  );  

  return (
    <>
      {/* Normal Card View */}
      <div className="bg-white p-6 rounded-xl shadow-md relative">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-semibold text-gray-800 text-center w-full">
            Billing Type
          </h3>
          <button
            onClick={() => setFocusMode(true)}
            className="absolute top-4 right-4 text-sm px-3 py-1.5 rounded-md bg-[#1A2B5C] text-white hover:bg-[#EE1D23] transition"
          >
            Focus Mode
          </button>
        </div>
        {renderChart()}
      </div>

      {/* Focus Mode Overlay */}
      {focusMode && (
        <div className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4">
          <div className="relative w-full max-w-5xl bg-white rounded-3xl p-8 shadow-2xl overflow-y-auto max-h-[90vh]">
            <button
              onClick={() => setFocusMode(false)}
              className="absolute top-4 right-4 bg-white rounded-full shadow p-2 hover:text-[#EE1D23] transition"
              title="Exit Focus Mode"
            >
              <XMarkIcon className="w-5 h-5" />
            </button>
            <h2 className="text-2xl font-bold mb-6 text-center text-[#1A2B5C]">
              Billing Type (Focus Mode)
            </h2>
            {renderChart(450)}
          </div>
        </div>
      )}
    </>
  );
};

export default BillingTypeRevenueChart;
